import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';

const SelectStudentMobileTarget = ({ onChange, onClose}) => {
    const [loading, setLoading] = useState(false);
    const [studentMobile, setStudentMobile] = useState(false);
    const [parentMobile, setParentMobile] = useState(true);
    const [create, setCreate] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={loading} />
        )
    }
    const saveItem = function(){
        var co = 0;
        if(studentMobile) co++;
        if(parentMobile) co++;
        if(co == 0){
            setErorVisible(true);
            setErrorMessage("هیچ نوع مخاطبی انتخاب نشده است");
            return;
        }
        onChange(studentMobile, parentMobile, create);        
    }
    const onCheckboxChange = (e, name) => {
        if(name == "student") setStudentMobile(e.checked);
        if(name == "parent") setParentMobile(e.checked);
        if(name == "create") setCreate(e.checked);
    }
    return (
        <>
            <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="انتخاب نوع مخاطب" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
                <table style={{width:"100%", borderCollapse:"collapse"}}>
                    <tbody>
                        <tr>
                            <td>
                                <div className="flex align-items-center" style={{marginTop:"10px"}}>
                                    <Checkbox inputId={"chk_0"} onChange={(e)=>{onCheckboxChange(e, "student")}} checked={studentMobile} />
                                    <label htmlFor={"chk_0"} className="ml-2"> &nbsp;موبایل دانش آموز</label>
                                </div>                
                            </td>
                        </tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                        <tr>
                            <td>
                                <div className="flex align-items-center" style={{marginTop:"10px"}}>
                                    <Checkbox inputId={"chk_1"} onChange={(e)=>{onCheckboxChange(e, "parent")}} checked={parentMobile} />
                                    <label htmlFor={"chk_1"} className="ml-2"> &nbsp;موبایل ولی</label>
                                </div>                
                            </td>
                        </tr>
                        <tr><td colSpan={2}><hr/></td></tr>
                        <tr>
                            <td style={{backgroundColor:"#d8f3d7ff"}}>
                                <div className="flex align-items-center" style={{marginTop:"10px", marginBottom:"10px"}}>
                                    <Checkbox inputId={"chk_2"} onChange={(e)=>{onCheckboxChange(e, "create")}} checked={create} />
                                    <label htmlFor={"chk_2"} className="ml-2"> &nbsp;پیامک با پنل ارسال نشود. می خواهم با موبایل خودم ارسال کنم</label>
                                </div>                
                            </td>
                        </tr>
                        <tr><td colSpan={2}>اگر گزینه فوق را تیک بزنید پیامک توسط پنل اینترنی ارسال نمی شود. 
                             در این حالت پیامک دخیره شده و می توانید با کمک اپلیکیشن کلاسیکو7 آنرا ارسال نمائید و موجب کاهش هزینه ارسال پیامک به نرخ همراه اول یا ایرانسل گردد. </td></tr>
                        <tr><td colSpan={2}><hr/></td></tr>
                        <tr><td colSpan={2}>&nbsp;</td></tr>
                    </tbody>
                </table>

            </Dialog>
        
              <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
};

export default SelectStudentMobileTarget;